import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import classNames from "classnames";
import FeatherIcon from "feather-icons-react";

// components
import Scrollbar from "./Scrollbar";
import { useDispatch,useSelector } from "react-redux";

import { IReduxState } from "../../utils/types";
import { clearAllNotificationsAction, getNotificationsAction, updateNotificationReadCount } from "../../Redux/Actions/AdminActions";
import { convertUtcToLocal } from "../../utils/functions";

const tabName = process.env.REACT_APP_TAB_NAME

// notifiaction continer styles
const notificationContainerStyle = {
  maxHeight: "230px",
  display: "none",
};

const notificationShowContainerStyle = {
  maxHeight: "230px",
};


interface NotificationContainerStyle {
  maxHeight?: string;
  display?: string;
}

const NotificationDropdown = (props:any) => {
  const adminState = useSelector((state: IReduxState) => state.Admin);
  const authState = useSelector((state: IReduxState) => state.Auth)
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [notificationContentStyle, setNotificationContentStyles] =
    useState<NotificationContainerStyle>(notificationContainerStyle);

  /*
   * toggle notification-dropdown
   */
  const toggleDropdown = () => {  
    dispatch(updateNotificationReadCount(adminState?.notificationList.length))  

    setDropdownOpen(!dropdownOpen);
    setNotificationContentStyles(
      notificationContentStyle === notificationContainerStyle
        ? notificationShowContainerStyle
        : notificationContainerStyle
    );
  }; 
 
  useEffect(() => {
    let syncNotificationID:any;
    
      dispatch(getNotificationsAction());
      syncNotificationID = setInterval(()=>{
        dispatch(getNotificationsAction());
      },15000)
    
    return ()=>{
        clearInterval(syncNotificationID);
    }
}, [dispatch]);

  const handleClearAll = async()=>{
    await dispatch(clearAllNotificationsAction());
    setDropdownOpen(!dropdownOpen);
  }
  
  let notification_read_count:any = localStorage.getItem('notification_read_count')?localStorage.getItem('notification_read_count'):0;

  useEffect(() => {
    let read_count:any = localStorage.getItem('notification_read_count')?localStorage.getItem('notification_read_count'):0; 

    if (adminState?.notificationList.length > 0 && read_count < adminState?.notificationList.length) { 
      document.title = `${authState.controlium_type && authState.logo_folder? authState.tenant_name : tabName ? tabName : "Controlium"} (${adminState?.notificationList.length - read_count })`;
    }else{
      document.title = `${authState.controlium_type && authState.logo_folder? authState.tenant_name : tabName ? tabName : "Controlium"}`
    }
  }, [adminState?.notificationList,adminState?.notification_read_count]);


  return (
    <Dropdown show={dropdownOpen} onToggle={toggleDropdown}> 
      <Dropdown.Toggle
        id="dropdown-notification"
        as="a"
        onClick={toggleDropdown}
        className={classNames(
          "nav-link",
          "position-relative",
          "cursor-pointer",
          {
            show: dropdownOpen,
          }
        )}
      >
        <FeatherIcon icon="bell" />
        {adminState?.notificationList.length > 0 && notification_read_count < adminState?.notificationList.length && !dropdownOpen  && 
          <span className="badge bg-danger rounded-circle noti-icon-badge">
            {adminState?.notificationList.length - notification_read_count }
          </span>
        }
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-end dropdown-lg">
        <div>
          <div className="dropdown-item noti-title">
            <h5 className="m-0">
              <span className="float-end" onClick={handleClearAll}>
                <Link to="#" className="text-dark">
                  <small >Clear All</small>
                </Link>
              </span>
              Notification
            </h5>
          </div>
          <Scrollbar className="noti-scroll" style={notificationContentStyle}>
              {adminState?.notificationList?.map((item:any, i:any) => {
               return (
                <div
                  className="dropdown-item notify-item border-bottom"
                  key={i + "-noti"}
                  style={{ display:'inline-block'}}
                >
                    <>
                      <div className={`notify-icon ${i  % 2 === 0 ? 'bg-primary' : 'bg-info' }`}> 
                        <i className="bi bi-file-code-fill" aria-setsize={20}></i>
                      </div>
                      <p className="notify-details">
                        {convertUtcToLocal(item.date,'DD/MM/YYYY HH:mm')}{" "}
                        <small className="text-muted overflowAuto notify-name">{item.name}</small>
                        <small className="text-muted">{item?.origin?`(${item?.origin})`:``}</small>
                      </p>
                    </>
                </div>
              );
            })}
          </Scrollbar>

           
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;